<template>
  <div style="height: 100%">
    <div class="box-header box box-between">
      <div class="box-header-left">
        <div class="box-header-left-text">
          文化积淀管理&nbsp;/&nbsp;稿件列表&nbsp;/&nbsp;
        </div>
        <div class="box-header-right">
          <div>稿件详情</div>
        </div>
      </div>
      <div class="box">
        <el-button style="font-size: 16px" @click="cancel" size="mini">
          <template class="box box-column-center">
            <span>返回</span>
          </template>
        </el-button>
      </div>
    </div>
    <div
      class="box"
      style="padding: 0;padding-bottom: 20px;position: relative; background: #ffffff;"
    >
      <div style="width: 33%;" class="border-right box box-column">
        <div class="topBg padding">
          <div class="titles">稿件预览</div>
          <div class="pageTitle">
            {{ info.title }}
          </div>
          <div class="box box-column-center box-between desc border-bottom">
            <span class="sqmp">{{ info.columnName }}</span>
            <div class="box box-column-center times">
              <i class="el-icon-time" style="color: #92979C;margin-right: 5px;"></i>
              <span>{{ info.publishTime }}</span>
            </div>
          </div>
        </div>
        <div class="contents padding">
          <div style="width: 100%;" class="rich-text" v-html="formattedData(info.content)"></div>
        </div>
      </div>
      <div class="box-1 padding">
        <div class="count">{{page.total}}条评论</div>
        <div class="pt-20 pb-20 box box-center" v-if="!messageList.length">
          <span class="cl-border">暂无评论数据</span>
        </div>
        <div class="list" v-else>
          <div class="box item" v-for="(items, indexs) in messageList" :key="indexs">
            <img src="@/assets/image/sh-tz.png" class="tx" />
            <div class="box-1 box box-column right">
              <div class="box box-column-center box-between">
                <span class="name">{{ items.createUsername }}</span>
                
                <el-popconfirm
                  title="确定删除该条评论吗?"
                  @confirm="confirmDel(items, indexs)"
                >
                  <el-button
                    slot="reference"
                    type="text"
                    icon="el-icon-delete"
                    style="color: #EB3538;"
                    >删除</el-button
                  >
                </el-popconfirm>
              </div>
              <div class="content" v-html="formattedData(items.commentContent)"></div>
              <div class="createTime">{{ items.createTime }}</div>
            </div>
          </div>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,prev, pager, next,sizes,jumper"
          :total="Number(page.total)"
          background
          :page-size="page.size"
          :current-page.sync="page.page"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :style="{ textAlign: 'right' }"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { commentDel, commentStoryPageQt, storyDetail } from "@/api/task.js";
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      messageList: [],
      page: {
        page: 1,
        size: 10,
        total: 0
      },
      info: {}
    };
  },
  mounted() {
    this.storyDetail();
    this.getItemInfo(1);
  },
  methods: {
    async storyDetail() {
      let params = {
        id: this.item.id,
      };
      let res = await storyDetail(params);
      if (res.data.code == 200) {
        this.info = res.data.data;
      } else return this.$message.error(res.data.msg)
    },
    // 得出评论表
    async getItemInfo(val) {
      if (val == 1) this.page.page = 1;
      let params = {
        storyId: this.item.id,
        size: this.page.size,
        page: this.page.page,
      };
      let res = await commentStoryPageQt(params);
      if (res.data.code == 200) {
        this.messageList = res.data ? (res.data.data.records
          ? res.data.data.records
          : []) : [];
        this.page.total = res.data ? res.data.data.total : 0;
      } else return this.$message.error(res.data.msg)
    },
    
    // 内容格式化
    formattedData(text) {
			// 将换行符替换为<br>标签
			return text && text.replace(/\n/g, "<br>").replace(/<img([^>]+)>/gi, (match, attr) => {
        // 检查是否已有 style 属性
        if (attr.includes('style=')) {
          // 已有 style，则在其中添加 width:100%;height:auto;（避免覆盖原有样式）
          return `<img${attr.replace(/style="([^"]*)"/gi, (s, style) => {
            // 移除可能存在的 width 和 height，避免冲突
            let newStyle = style.replace(/width:[^;]+;?/gi, '').replace(/height:[^;]+;?/gi, '');
            // 添加新样式（确保末尾有分号，避免拼接问题）
            newStyle = newStyle.trim() ? `${newStyle};width:100%;height:auto;` : 'width:100%;height:auto;';
            return `style="${newStyle}"`;
          })}>`;
        } else {
          // 没有 style，则直接添加
          return `<img${attr} style="width:100%;height:auto;">`;
        }
      });
		},

    // 删除评论事件
    async confirmDel (items, indexs) {
      let params = {
        id: items.id
      };
      let res = await commentDel(params);
      if (res.data.code == 200) {
        this.$message.success('已删除');
        this.messageList.splice(indexs, 1);
        if (this.messageList.length) this.page.total--;
        else this.getItemInfo(1);
      }
    },

    handleSizeChange(size) {
      this.page.size = size;
      this.getItemInfo(1);
    },

    handleCurrentChange(page) {
      this.page.page = page;
      this.getItemInfo();
    },

    // 返回
    cancel() {
      this.$emit("closeDialog");
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/components/less.less";
.border-right {
  border-right: 1px solid #e0e0e0;
}
.padding {
  padding: 30px;
}
.topBg {
  background: url('~@/assets/image/img/gaojian.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
/deep/ .rich-text img {
  width: 100% !important;
}
/deep/ .rich-text section {
  max-width: 100% !important;
}
/deep/ [v-html] img {
  width: 100% !important;
  height: auto;
}
.titles {
  font-family: MiSans;
  font-size: 20px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0px;

  color: #494c4f;
  margin-bottom: 24px;
}
.pageTitle {
  font-family: MiSans;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 0px;

  font-variation-settings: "opsz" auto;
  color: #313436;
  margin-bottom: 15px;
}
.desc {
  padding-bottom: 28px;
  .sqmp {
    padding: 2px 8px;
    font-family: MiSans;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    border-radius: 4px;
    font-variation-settings: "opsz" auto;
    color: #ffffff;
    background: #4c7edf;
  }
  .times {
    font-family: MiSans;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0px;

    color: #494c4f;
  }
}
.contents {
  font-family: MiSans;
  font-size: 16px;
  font-weight: normal;
  line-height: 28px;
  letter-spacing: 0px;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #313436;
  height: 60vh;
  overflow-y: auto;
}
.count {
  font-family: MiSans;
  font-size: 20px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0px;

  color: #494c4f;
  margin-bottom: 24px;
}
.list {
  max-height: 70vh;
  overflow-y: auto;
  .item {
    .tx {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    .right {
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: 1px solid #e4e4e4;
    }
    .name {
      font-family: MiSans;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0px;

      font-variation-settings: "opsz" auto;
      color: #494c4f;
    }
    .content {
      font-family: MiSans;
      font-size: 16px;
      font-weight: normal;
      line-height: 24px;
      letter-spacing: 0px;

      color: #494c4f;
      margin-bottom: 6px;
    }
    .createTime {
      font-family: MiSans;
      font-size: 14px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0px;

      font-variation-settings: "opsz" auto;
      color: #92979c;
    }
  }
}
.box {
  display: flex;
}
.box-1 {
  flex: 1;
}
.box-2 {
  flex: 2;
}
.box-3 {
  flex: 3;
}
.box-7 {
  flex: 7;
}
.box-wrap {
  flex-wrap: wrap;
}
.box-column {
  flex-direction: column;
}
.box-column-center {
  align-items: center;
}
.box-center {
  justify-content: center;
}
.box-center {
  justify-content: center;
  align-items: center;
}
.box-between {
  justify-content: space-between;
}
.border-bottom {
  border-bottom: 1px solid #e4e4e4;
}
.p-15 {
  padding: 15px;
}
.pb-10 {
  padding-bottom: 10px;
}
.pb-20 {
  padding-bottom: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-10 {
  margin-right: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.bold {
  font-weight: bold;
}
.w100 {
  width: 130px;
}
.mb-10 {
  margin-bottom: 10px;
}
.pointer {
  cursor: pointer;
}
.mt-16 {
  margin-top: 16px;
}
.p-10 {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/culturalManage/detail.vue